<template>
	<div class="llogin" @click="closeproject">
		<div class="login" @click.stop="">
			<div class="from padding">
				<p class="title text-333 text-bold text-left margin-bottom margin-top-sm">添加项目经历</p>
				<el-form :label-position="labelPosition" label-width="80px" :model="project" :rules="rules"
					ref="formLabelAlign" class="">
					<el-form-item label="项目名称" prop="title">
						<div class="padding-lr-sm">
							<el-input type="text" maxlength="50" v-model.number="project.title" autocomplete="off" placeholder="请输入名称">
							</el-input>
						</div>
					</el-form-item>
				<el-form-item label="完工时间" prop="date">
					<div class="padding-lr-sm">
						 <!-- <el-date-picker type="date" @change="change" v-model="project.date" style="width: 100%;"></el-date-picker> -->
						 <!-- <el-date-picker type="date" v-model=""> </el-date-picker> -->
						 <el-input type="text" maxlength="50" v-model.number="project.date" autocomplete="off" placeholder="请输入名称">
						 </el-input>
					</div>
				</el-form-item>
				<el-form-item label="所在地区" prop="area">
					<div class="padding-lr-sm">
						<el-input type="text" maxlength="50" v-model.number="project.area" autocomplete="off" placeholder="请输入名称">
						</el-input>
					</div>
				</el-form-item>
					<el-form-item label="工作内容" prop="content">
						<textarea class="txtmep padding-sm bge margin-lr-sm" v-model="project.content" placeholder="请输入详细的个人介绍例如工作经验相关内容..."></textarea>
					</el-form-item>
					<el-form-item label="项目风采">
						<div class="flex margin-lr-sm">
							<div class="width700 margin-right-sm">
								<el-upload
								  class="avatar-uploader"
								  action="https://manage.ciiply.com/api/pc/user/upFile"
								  :show-file-list="false"
								  :on-success="handleSuccess">
								  <img v-if="firstimg" :src="firstimg" class="uploadimg">
								  <img v-else class="uploadimg" src="https://wz89.lzym.top/web/static/home/add.png">
								</el-upload>
							</div>
							<div class="width700 margin-right-sm">
								<el-upload
								  class="avatar-uploader"
								  action="https://manage.ciiply.com/api/pc/user/upFile"
								  :show-file-list="false"
								  :on-success="handletwoSuccess">
								  <img v-if="secodimg" :src="secodimg" class="uploadimg">
								  <img v-else class="uploadimg" src="https://wz89.lzym.top/web/static/home/add.png">
								</el-upload>
							</div>
							<div class="width700">
								<el-upload
								  class="avatar-uploader"
								  action="https://manage.ciiply.com/api/pc/user/upFile"
								  :show-file-list="false"
								  :on-success="handlethreeSuccess">
								  <img v-if="threeimg" :src="threeimg" class="uploadimg">
								  <img v-else class="uploadimg" src="https://wz89.lzym.top/web/static/home/add.png">
								</el-upload>
							</div>
						</div>
					</el-form-item>
					<el-button type="primary" @click="submitForm('formLabelAlign')">确认添加</el-button>
					
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				labelPosition: 'left',
				project:{
					title: '', //项目名称
					date:'2000-05-23',//完工时间
					area:'',//所在地区
					content:'',//工作内容
				},
				sfa:'',
				firstimg:'',//
				secodimg:'',//
				threeimg:'',//
				rules: {
					
					title: [{
						required: true,
						message: '请填写求职标题',
						trigger: 'blur'
					}],
					date: [{
						required: true,
						message: '请选择完工时间',
						trigger: 'blur'
					}],
					area: [{
						required: true,
						message: '请填写所在地区',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请输入详细的个人介绍例如工作经验相关内容',
						trigger: 'blur'
					}],
				}, //表单校验规则
				id:'',//
				isedut:false,//是否是编辑
			};
		},
		created(){
			Bus.$on('editpro',item=>{
				this.id = item.id
				this.isedut = true
				this.getinfo(item.id)
			})
		},
		destroyed() {
			Bus.$off('editpro')
		},
		methods: {
			/**
			 * 获取已填写的基本信息
			 * */
			getinfo(id) {
				this.ajax('get', '/api/pc/userInfo/myUserInfo',{
					
				}, res => {
					if (res.status == 200) {
						let experience = res.data.experience
						experience.map(ele=>{
							if(ele.id == id){
								this.project.title = ele.work_name
								this.project.date = ele.end_time
								this.project.area = ele.area
								this.project.content = ele.work_content
								if(ele.images&&ele.images.length!=0){
									if(ele.images.length == 1){
										this.firstimg = ele.images[0]
									}
									if(ele.images.length == 2){
										this.firstimg = ele.images[0]
										this.secodimg = ele.images[1]
									}
									if(ele.images.length == 3){
										this.firstimg = ele.images[0]
										this.secodimg = ele.images[1]
										this.threeimg = ele.images[2]
									}
								}
							}
						})
					} else {
						this.$message(res.msg);
					}
				})
				
			},
			//关闭添加章节弹窗
			closeproject(){
				this.$emit('closeproject')
				Bus.$off('editpro')
			},
			//上转第一张
			handleSuccess(file){
				this.firstimg = file.data.url;
			},
			handletwoSuccess(file){
				this.secodimg = file.data.url;
			},
			handlethreeSuccess(file){
				this.threeimg = file.data.url;
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.add()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			change(e){
				console.log(e);
			},
			/**
			 * 添加证书
			 * */
			add(){
				let images = []
				if(this.firstimg){
					images.push(this.firstimg)
				}
				if(this.secodimg){
					images.push(this.secodimg)
				}
				if(this.threeimg){
					images.push(this.threeimg)
				}
				let data={
					work_name:this.project.title,
					work_content:this.project.content,
					end_time:this.project.date,
					area:this.project.area,
					images:images.join('|'),
				}
				if(this.isedut){
					data.id= this.id
				}
				this.ajax('post', '/api/pc/userInfo/editExperience',data, res => {
					console.log(res);
					if(res.status == 200){
						Bus.$emit('addok')
						this.$message("提交成功")
						this.closeproject()
					}else{
						this.$message(res.msg);
					}
				})
			},
			/**
			 * 编辑证书
			 * */
			editcour(){
				let data={
					
				}
				
				this.ajax('post', '/api/',data, res => {
					console.log(res);
					if(res.status == 200){
						
					}else{
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped>
	/deep/ .el-input{
		text-align: left;
	}
	/deep/ .el-input>input {
		
		height: 54px;
		width: 340px;
	}
	.txtmep {
		width: 100%;
		height: 162px;
		border: 1px solid #E6E6E6;
		border-radius: 8px;
		outline: 0;
	}
	.llogin {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		background: rgba(0, 0, 0, 0.6600);
		z-index: 999999;
	}

	.login {
		width: 941px;
		height: 775px;
		background: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 20px;
	}

	.title {
		font-size: 28px
	}
	.uploadimg{
		width: 129px;
		height: 122px;
	}
	/deep/ .el-button {
		width: 383px;
		height: 60px;
		/* line-height: 60px; */
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9,130,123,0.2000);
		border-radius: 30px;
		position: absolute;
		/* bottom: 105px; */
		left: 50%;
		transform: translateX(-50%);
	}
</style>



// WEBPACK FOOTER //
// src/view/my/addproject.vue